import React from 'react';
import { Label } from '../Label';
import Box from '@mui/material/Box';
import { colorPalette } from '../../../colorPalette';
export const FastDeliveryLabel = () => (React.createElement(Label, { icon: "FastShippingOutlined", backgroundColor: "white", textColor: "red600", fontWeight: 400, fontSize: "10px", letterSpacing: "normal", border: `1px solid ${colorPalette.gray200}`, padding: "small" },
    "Livraison\u00A0",
    React.createElement(Box, { component: "span", sx: { fontWeight: 600 } }, "Rapide")));
